import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Preloader from "../components/Preloader";
import MagnetCursor from "../components/MagnetCursor";
import ScrollToTop from "../components/ScrollToTop";

const SERVICES_API = "https://backenddev.aaerlaw.com/api/user/paraclearth_services";

function ServiceDetails() {
  const location = useLocation();
  const id = new URLSearchParams(location.search).get("id");

  const [service, setService] = useState(null);
  const [allServices, setAllServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) preloader.style.display = "none";
  }, []);

  useEffect(() => {
    if (!id) { setNotFound(true); setLoading(false); return; }

    Promise.all([
      fetch(`${SERVICES_API}/${id}`).then((r) => {
        if (!r.ok) throw new Error("not found");
        return r.json();
      }),
      fetch(`${SERVICES_API}?page=1&limit=50`).then((r) => r.json()),
    ])
      .then(([svc, list]) => {
        setService(svc);
        if (Array.isArray(list?.data)) setAllServices(list.data);
      })
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div>
        <Preloader />
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
          <div className="spinner-border text-secondary" role="status">
            <span className="visually-hidden">Loading&hellip;</span>
          </div>
        </div>
      </div>
    );
  }

  if (notFound || !service) {
    return (
      <div>
        <Preloader />
        <div className="text-center py-5">
          <p>Service not found.</p>
          <Link to="/service" className="btn btn-primary">View All Services</Link>
        </div>
        <ScrollToTop />
        <MagnetCursor />
      </div>
    );
  }

  return (
    <div>
      {/* Preloader */}
      <Preloader />

      {/* Breadcrumb Section */}
      <div
        className="breadcrumb-section breadcrumb-compact bg-img jarallax"
        data-jarallax=""
        data-speed="0.6"
        style={{ backgroundImage: "url('assets/img/bg-img/73.jpg')" }}
      >
        <div className="divider"></div>
        <div className="container">
          <div className="breadcrumb-content">
            <h2
              className="wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="700ms"
            >
              {service.title}
            </h2>
            <ul
              className="list-unstyled wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="1000ms"
            >
              <li>
                <Link className="magnet-link" to="/">
                  Home
                </Link>
              </li>
              <li>
                <Link className="magnet-link" to="/service">
                  Services
                </Link>
              </li>
              <li>{service.title}</li>
            </ul>
          </div>
        </div>
        <div className="divider"></div>
      </div>

      {/* Service Details Section */}
      <div className="service-details-section bg-white">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-5">
            {/* Main Content */}
            <div className="col-12 col-lg-8">
              <div className="service-details-content">
                {service.icon && (
                  <div className="mb-4" style={{ fontSize: "48px", color: "#1c1d20" }}>
                    <i className={service.icon}></i>
                  </div>
                )}
                <div className="h2 mb-3">{service.title}</div>
                {service.summary && (
                  <p className="lead mb-4">{service.summary}</p>
                )}
                {service.description && (
                  <div dangerouslySetInnerHTML={{ __html: service.description }} />
                )}
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-12 col-lg-4">
              <div className="d-flex flex-column gap-5">
                {/* All Services Widget */}
                {allServices.length > 0 && (
                  <div className="service-widget">
                    <div className="h4 fw-semibold mb-4">Our Services</div>
                    <ul className="service-list">
                      {allServices.map((s) => (
                        <li key={s.id}>
                          <Link
                            to={`/servicedetails?id=${s.id}`}
                            style={String(s.id) === String(id) ? { fontWeight: 700 } : {}}
                          >
                            {s.title}
                            <i className="ti ti-arrow-right"></i>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Helpline Card */}
                <div
                  className="helpline-card bg-img"
                  style={{ backgroundImage: "url('assets/img/bg-img/75.jpg')" }}
                >
                  <div className="h3 mb-2 fw-semibold text-white">
                    How Can We Help?
                  </div>
                  <p className="mb-4 text-white">
                    Our team is ready to assist you. Get in touch today.
                  </p>
                  <Link to="/bookconsultation" className="btn btn-primary">
                    <span>
                      Book Consultation <i className="ti ti-arrow-up-right"></i>
                    </span>
                    <span>
                      Book Consultation <i className="ti ti-arrow-up-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </div>

      {/* Scroll To Top */}
      <ScrollToTop />
      {/* Magnet Cursor */}
      <MagnetCursor />
    </div>
  );
}

export default ServiceDetails;
